import { useQuery } from "@tanstack/react-query";
import { GetBulkPayments, GetBulkPaymentDetail } from "../Api/bulk_payment_api";
import { unwrapApiResponse, ServiceQueryOptions } from "./query_helpers";
import { DEFAULT_STALE_TIME } from "../Constant/AppConstants";

export const useBulkPaymentsQuery = (
  params: Parameters<typeof GetBulkPayments>[0],
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    ...options,
    queryKey: ["bulkPayments", params],
    queryFn: async () => unwrapApiResponse(await GetBulkPayments(params)),
  });
};

export const useBulkPaymentDetailQuery = (
  id: string | null,
  options?: ServiceQueryOptions,
) => {
  return useQuery({
    staleTime: DEFAULT_STALE_TIME,
    enabled: !!id,
    ...options,
    queryKey: ["bulkPaymentDetail", id],
    queryFn: async () => unwrapApiResponse(await GetBulkPaymentDetail(id!)),
  });
};
